import React from 'react'
import { menuList } from '@/module/home/constant'
import { Link, useNavigate } from 'react-router-dom'
import { useSelected } from '@/module/home/hook'
import { useAuth } from '@/module/auth/hook'
import { useSignout } from '@/api/hook'

function SideMenu() {
  const { user } = useAuth()
  const { productType } = useSelected()
  const signoutMutation = useSignout();

  const handleSignout = () => {
    signoutMutation.mutate(undefined, {
      onError: (error) => {
        console.error('로그아웃 중 오류 발생:', error);
      }
    });
  };

  return (
    <header className='navbar hidden h-screen bg-base-100 lg:flex lg:w-[300px] lg:flex-col'>
      <div className='flex-none w-full justify-left'>
        <div className='p-3 font-bold select-none'>
          <span className='text-xl text-primary'>Flexcil</span>
          <p>
            <span className='text-2xl'>Domain Manager</span>
          </p>
        </div>
      </div>
      <div className='items-start flex-1 w-full mt-2'>
        <ul className='w-full p-2 menu rounded-box'>
          <li className='menu-title'>
            <span>상품 목록</span>
          </li>
          {menuList.map((menu) => (
            <li key={menu.id}>
              <Link to={`/${menu.id}`} className={`${menu.id === productType ? 'active' : ''}`}>
                {menu.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className='flex items-center w-full'>
        <div className='dropdown-top dropdown'>
          <label tabIndex={0} className='btn-ghost btn-circle avatar btn'>
            <div className='w-8 rounded-full'>
              <img src={user.picture} alt={`${user.name}'s profile`} />
            </div>
          </label>
          <ul
            tabIndex={0}
            className='p-2 mt-3 shadow dropdown-content menu w-52 rounded-box bg-base-100'
          >
            <li>
              <button 
                  onClick={handleSignout}>
                  Logout
              </button>
            </li>
          </ul>
        </div>
        <div className='text-sm'>{user.name}</div>
      </div>
    </header>
  )
}

export default SideMenu
